import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { notificationsActions } from "modules/notifications/slices";
import { NOTIFICATION_TYPES } from "modules/notifications/types";
import { isPollStoppedSaga } from "modules/polling/sagas";
import { SagaIterator } from "redux-saga";
import { all, call, put, takeLeading } from "redux-saga/effects";
import { getAxiosErrorMessage } from "utils/getAxiosErrorMessage";
import { axiosInstance } from "../../axios";
import { nlpActions } from "./slices";
import {
  GetEmotionsPredictionParams,
  GetEmotionsPredictionResponse
} from "./types";

const serviceApiPath = `${window.origin}/process/`;

export function* getEmotionsPreditionSaga(
  action: PayloadAction<GetEmotionsPredictionParams>
): SagaIterator<void> {
  try {
    const response: AxiosResponse<GetEmotionsPredictionResponse> = yield call(
      axiosInstance.post,
      serviceApiPath,
      {
        articles: [{ text: action.payload.text }]
      }
    );
    const isPollStopped: boolean = yield call(isPollStoppedSaga, action);
    if (!isPollStopped) {
      yield put(nlpActions.getEmotionsPredictionSuccess(response.data));
    }
  } catch (e) {
    yield put(
      nlpActions.getEmotionsPredictionFailure({
        params: action.payload,
        error: getAxiosErrorMessage(e)
      })
    );
    yield put(
      notificationsActions.showNotification({
        title: "Failed to get emotions prediction data",
        text: getAxiosErrorMessage(e),
        type: NOTIFICATION_TYPES.ERROR
      })
    );
  }
}

export function* watcherSaga(): SagaIterator<void> {
  yield all([
    takeLeading(
      nlpActions.getEmotionsPredictionRequest,
      getEmotionsPreditionSaga
    )
  ]);
}
